export default __webpack_public_path__ + "static/media/check-inactive.6cb1b6bb.svg";